function sliders() {

    const layoutSliderSettings = {
        slidesToShow: 1,
        arrows: false
    };

    const $body = $( 'body' );

    $body
        .on( 'click', '.slider-container .slider-controls .left, .slider-container .slider-controls .right', function () {
            if ( $( this ).hasClass( 'disabled' ) ) {
                return false;
            }

            const $sliderContainer = $( this ).closest( '.slider-container' );
            const $slider = $( '.slider', $sliderContainer );

            if ( $( this ).hasClass( 'left' ) ) {
                $slider.slick( 'slickPrev' );
            } else {
                $slider.slick( 'slickNext' );
            }
        } )
        .on( 'init', '.slider-container .slider', function ( event, slick ) {
            const $sliderContainer = $( this ).closest( '.slider-container' );

            if ( $sliderContainer.hasClass( 'non-infinite-controls' ) ) {
                const currentSlide = slick.slickCurrentSlide();

                if ( 0 === currentSlide ) {
                    $( '.slider-controls .left', $sliderContainer ).addClass( 'disabled' );
                }

                if ( ( slick.$slides.length - 1 ) === currentSlide ) {
                    $( '.slider-controls .right', $sliderContainer ).addClass( 'disabled' );
                }
            }
        } )
        .on( 'afterChange', '.slider-container .slider', function ( event, slick, currentSlide ) {
            const $sliderContainer = $( this ).closest( '.slider-container' );
            const $tabs = $( '.tabs', $sliderContainer );

            $( '.current-slide-number', $sliderContainer ).text( currentSlide + 1 );

            if ( $sliderContainer.hasClass( 'non-infinite-controls' ) ) {
                if ( 0 === currentSlide ) {
                    $( '.slider-controls .left', $sliderContainer ).addClass( 'disabled' );
                } else {
                    $( '.slider-controls .left', $sliderContainer ).removeClass( 'disabled' );
                }

                if ( ( slick.$slides.length - 1 ) === currentSlide ) {
                    $( '.slider-controls .right', $sliderContainer ).addClass( 'disabled' );
                } else {
                    $( '.slider-controls .right', $sliderContainer ).removeClass( 'disabled' );
                }
            }

            if ( $tabs.length > 0 ) {
                var $activeTab = null;

                $( 'li', $tabs ).each( function () {
                    var tabIndex = 'undefined' === typeof $( this ).data( 'index' ) ? $( this ).index() : $( this ).data( 'index' );

                    if ( tabIndex <= currentSlide ) {
                        $activeTab = $( this );
                    }
                } );

                $( 'li', $tabs ).not( $activeTab ).removeClass( 'active' );
                $activeTab.addClass( 'active' );
            }
        } )
        .on( 'click', '.slider-container .tabs li', function () {
            const $sliderContainer = $( this ).closest( '.slider-container' );
            const $slider = $( '.slider', $sliderContainer );

            $slider.slick( 'slickGoTo', 'undefined' === typeof $( this ).data( 'index' ) ? $( this ).index() : $( this ).data( 'index' ) );
        } )
    ;

    startSlider( $( '.slider-container.carousel-slider' ), layoutSliderSettings );

}

function isFirstSlide( current, next ) {
    return ( current === 1 && next === 0 );
}

function isLastSlide( current, next, length ) {
    return ( current === length - 2 && next === length - 1 );
}

function startSlider( $sliderContainers, settings ) {
    if ( $sliderContainers.length < 1 ) {
        return;
    }

    $sliderContainers.each( function () {
        const $sliderContainer = $( this );
        const $slider = $( '.slider', $sliderContainer );

        const $tabs = $( '.tabs', $sliderContainer );
        const $activeTab = $( 'li.active', $tabs );
        var startAtIndex = null;

        if ( $activeTab.length > 0 ) {
            startAtIndex = 'undefined' !== typeof $activeTab.data( 'index' ) ? $activeTab.data( 'index' ) : $activeTab.index();
        }

        $slider.addClass( 'show-slider' ).slick( settings );

        if ( null !== startAtIndex ) {
            $slider.slick( 'slickGoTo', startAtIndex );
        }
    } );

}

